import React, { useState, useEffect } from "react";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { toast } from "react-toastify";
import Pagination from "../../components/Pagination";
import { isEmpty } from "lodash";

const BANNER_TYPES = [{ value: "home_top", label: "Home Top Slider" }];

const getBannerTypeLabel = (type) =>
  BANNER_TYPES.find((t) => t.value === type)?.label || "N/A";

const Banner = () => {
  const [bannerData, setBannerData] = useState([]);
  const [isLoader, setLoader] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [newType, setNewType] = useState("home_top");
  const [newImage, setNewImage] = useState(null);

  // Delete Confirm
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  // Preview Image
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const getBannerData = async () => {
    const { status, data: response_banner } = await apiPost(apiPath.bannerList);
    if (status === 200) {
      if (response_banner.success) {
        setBannerData(response_banner.results);
      }
    }
  };

  useEffect(() => {
    getBannerData();
  }, []);


  const openAddModal = () => {
    setNewType("home_top");
    setNewImage(null);
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
  };
  const uploadImage = async () => {
    const form = new FormData();
    form.append("BannerFile", newImage);
    const { status, data: response_upload } = await apiPost(
      apiPath.uploadBanner,
      form,
      { headers: { "Content-Type": undefined } },
    );
    if (!isEmpty(response_upload)) {
      return response_upload?.path;
    }
    return false;
  };
  const onSubmitAdd = async () => {
    if (!newImage) {
      toast.error("Please select image");
      return;
    }
    setLoader(true);
    try {
      const bannerPath = await uploadImage();
      if (!bannerPath) {
        setLoader(false);
        toast.error("Image upload failed");
        return;
      }
      const { status, data: response_banner } = await apiPost(
        apiPath.addBanner,
        { banner_path: bannerPath, type: newType },
      );
      if (status === 200) {
        if (response_banner.success) {
          setLoader(false);
          toast.success(response_banner.message);
          setShowAddModal(false);
          getBannerData();
        } else {
          setLoader(false);
          toast.error(response_banner.message);
        }
      }
    } catch (err) {
      setLoader(false);
      toast.error(err?.response?.data?.message || "Something went wrong");
    }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId("");
  };

  const onConfirmDelete = async () => {
    const { status, data: response_banner } = await apiPost(
      apiPath.deleteBanner,
      { bannerId: deleteId },
    );
    if (status === 200) {
      if (response_banner.success) {
        toast.success(response_banner.message);
        closeDeleteModal();
        getBannerData();
      } else {
        toast.error(response_banner.message);
      }
    }
  };

  const openPreview = (image) => {
    setPreviewImage(image);
    setShowPreviewModal(true);
  };

  const closePreview = () => {
    setShowPreviewModal(false);
    setPreviewImage("");
  };

  return (
    <div className="main_wrap">
      <h2>Banner</h2>

      <div className="function-wrap funwrap">
        <div>
          <a className="btn-send" onClick={openAddModal}>
            Add New
          </a>
        </div>
        <div>
          <span className="spacer" />
          <p style={{ verticalAlign: "middle" }}>
            Total Records: {bannerData?.length || 0}
          </p>
        </div>
      </div>

      <div className="table-container">
        <table className="table01">
          <thead>
            <tr className="ng-table-sort-header">
              <th width="5%" className="align-L">
                Sr No.
              </th>
              <th width="15%" className="align-L">
                Banner Image
              </th>
              <th className="align-L">Category</th>
              <th width="10%" className="align-L">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {bannerData?.length > 0 ? (
              bannerData?.map((item, index) => (
                <tr key={item?._id || index}>
                  <td className="align-L">
                    {index + 1}
                  </td>
                  <td className="align-L">
                    {item?.banner_path ? (
                      <img
                        style={{
                          width: "120px",
                          height: "100px",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                        src={
                          process.env.REACT_APP_API_BASE_URL + item?.banner_path
                        }
                        onClick={() =>
                          openPreview(
                            process.env.REACT_APP_API_BASE_URL +
                              item?.banner_path,
                          )
                        }
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="align-L">{getBannerTypeLabel(item?.type)}</td>
                  <td className="align-L">
                    <a
                      className="btn"
                      onClick={() => openDeleteModal(item?._id)}
                    >
                      Delete
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="align-C">
                  <em>No Record Found</em>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


      <div
        className="pop_bg"
        style={{
          height: "100%",
          width: "100%",
          display: showAddModal ? "block" : "none",
        }}
      >
        <div className="pop_box pop_refer">
          <a href="#" className="close_pop" onClick={closeAddModal}>
            close_pop
          </a>
          <div className="modal-header">
            <h3>Add New Banner</h3>
          </div>
          <div className="modal-content">
            <div className="ticker-details">
              <div className="input-group">
                <label htmlFor="type" style={{ display: "block" }}>
                  Type:{" "}
                </label>
                <select
                  id="type"
                  className="w-100 p-2"
                  value={newType}
                  onChange={(e) => setNewType(e.target.value)}
                >
                  {BANNER_TYPES.map((t) => (
                    <option key={t.value} value={t.value}>
                      {t.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group">
                <label htmlFor="bannerImage" style={{ display: "block" }}>
                  Image:{" "}
                </label>
                <input
                  id="bannerImage"
                  type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={(e) => setNewImage(e.target.files[0])}
                />
                <span style={{ color: "red" }}>Size should be 450*80</span>
              </div>
              {newImage && (
                <div className="input-group">
                  <img
                    style={{
                      width: "120px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                    src={URL.createObjectURL(newImage)}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <div className="btn_box">
              <button
                className="btn-send"
                style={{ width: "100%" }}
                onClick={onSubmitAdd}
                disabled={isLoader}
              >
                {isLoader ? "Loading..." : "Add New"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirm Modal */}
      <div
        id="confirmationmodal"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
        aria-modal="true"
        className="modal"
        style={{
          display: showDeleteModal ? "block" : "none",
          position: "fixed",
          inset: "0",
          width: "100%",
          height: "100%",
          zIndex: "80",
          marginLeft: "0",
          background: "linear-gradient(45deg,rgba(0,0,0,.3),rgba(0,0,0,.3))",
        }}
      >
        <div className="modal-md modal-dialog-scrollable pop_box1">
          <span tabIndex={0} />
          <div id="modal_content_" tabIndex={-1} className="modal-content">
            <header
              style={{
                background: "#dff0d8",
                padding: "9px 15px",
                borderBottom: "1px solid #e5e5e5",
              }}
              id="modal_header_"
              className="modal-header"
            >
              <h4
                id="popup_title"
                className="modal-title text-uppercase"
                style={{
                  fontWeight: "bold",
                  fontFamily: "Tahoma, Helvetica, sans-serif",
                  fontSize: "12px",
                  color: "black",
                }}
              >
                Delete
              </h4>
            </header>

            <div id="modal_body_" className="modal-body">
              <div
                className="form-group"
                style={{ display: "table", width: "100%", margin: "5px 0px" }}
              >
                <div role="alert" aria-live="polite" aria-atomic="true" style={{ margin: "0" }}>
                  <div direction="right">
                    <span id="popup_msg" style={{ fontSize: "15px" }}>
                      Are you sure to delete this banner?
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-12 col-12 text-right"
                style={{ display: "flex", placeContent: "center", marginTop: "20px" }}
              >
                <button
                  type="button"
                  id="popup_confirm"
                  className="btn-send close_modal"
                  style={{ width: "100px", marginRight: "12px" }}
                  disabled={isLoader}
                  onClick={onConfirmDelete}
                >
                  <i className="fa fa-check-circle" />{" "}
                  {isLoader ? "...Loading" : "Confirm"}
                </button>

                <button
                  type="button"
                  className="btn-send close_modal"
                  style={{ width: "100px" }}
                  onClick={closeDeleteModal}
                >
                  <i className="fa fa-times-circle" /> Cancel
                </button>
              </div>
            </div>
          </div>
          <span tabIndex={0} />
        </div>
      </div>

      {/* Preview Image Modal */}
      <div
        className="pop_bg"
        style={{
          height: "100%",
          width: "100%",
          display: showPreviewModal ? "block" : "none",
        }}
      >
        <div className="pop_box pop_refer">
          <a href="#" className="close_pop" onClick={closePreview}>
            close_pop
          </a>
          <div className="modal-content">
            {previewImage && (
              <img style={{ width: "100%" }} src={previewImage} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
